import './App.css';
import { Grommet } from 'grommet';
import Canvas from './components/Canvas';

function App() {

  const theme = {
    global: {
      font: {
        family: "Roboto",
        size: "18px",
        height: "20px",
      },
    },
  };

  return (
    <Grommet theme={theme} full>
    {/* <div className="App"> */}
      <Canvas />
    {/* </div> */}
    </Grommet>
  );
}

export default App;
